import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

const VerifyEmailView = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      if (!token || !apiUrl) {
        setStatus('invalid');
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });

        if (!response.ok) {
          setStatus('invalid');
          return;
        }

        const data = await response.json();
        const verificationStatus = data?.status || data?.data?.status;
        setStatus(verificationStatus === 'verified' ? 'verified' : 'invalid');
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('invalid');
      }
    };

    verifyEmail();
  }, [searchParams, apiUrl]);

  if (status === 'verifying') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>Verifying your email...</div>
        </div>
      </div>
    );
  }

  if (status === 'verified') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
        <Result
          icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
          title="Email Verified"
          subTitle="Your email has been verified successfully."
          extra={[
            <Button type="primary" key="login" onClick={() => navigate('/login')}>
              Go to Login
            </Button>,
          ]}
        />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <Result
        icon={<CloseCircleTwoTone twoToneColor="#ff4d4f" />}
        title="Invalid Verification Link"
        subTitle="This verification link is invalid or has expired."
        extra={[
          <Button type="primary" key="home" onClick={() => navigate('/login')}>
            Back to Login
          </Button>,
        ]}
      />
    </div>
  );
};

export default VerifyEmailView;
